import { Star, Sparkles, MapPin } from 'lucide-react';
import { ExclusiveOffers } from '@/components/ExclusiveOffers';

export default function Home() {
  const reviews = [
    {
      text: "Value for money services with superb staff.",
      author: "Satisfied Customer"
    },
    {
      text: "My wife got pedicure and nail art done and was very happy too.",
      author: "Happy Client"
    },
    {
      text: "Best salon in Thakur Complex, very professional.",
      author: "Regular Visitor"
    }
  ];

  const handleBooking = () => {
    const message = encodeURIComponent("Hi, I'd like to book an appointment at Magic Touch Salon.");
    window.open(`https://wa.me/919870214490?text=${message}`, '_blank');
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 z-0"
          style={{
            backgroundImage: 'url(https://images.unsplash.com/photo-1744095407400-aa337918bbb1?crop=entropy&cs=srgb&fm=jpg&q=85)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/70 to-black"></div>
        </div>
        
        <div className="relative z-10 text-center px-4 max-w-5xl mx-auto">
          <div className="flex items-center justify-center mb-6 space-x-2">
            <Sparkles className="text-[#D4AF37]" size={32} />
          </div>
          <h1 
            className="text-4xl sm:text-5xl lg:text-7xl font-bold mb-6 text-white leading-tight"
            data-testid="hero-headline"
          >
            Experience the Magic <br />
            <span className="text-[#D4AF37] text-shadow-gold">of Style</span>
          </h1>
          <p className="text-lg sm:text-xl text-[#A3A3A3] mb-4 max-w-2xl mx-auto">
            Premium Unisex Salon in Kandivali
          </p>
          <div className="flex items-center justify-center space-x-2 mb-8">
            {[1, 2, 3, 4].map((star) => (
              <Star key={star} className="text-[#D4AF37] fill-[#D4AF37]" size={20} />
            ))}
            <Star className="text-[#D4AF37] fill-[#D4AF37]" size={20} style={{ opacity: 0.5 }} />
            <span className="text-white ml-2">4.5 on Google</span>
          </div>
          <button
            data-testid="book-appointment-btn"
            onClick={handleBooking}
            className="bg-[#D4AF37] text-black font-semibold px-12 py-4 uppercase tracking-widest text-sm hover:bg-[#E5C15D] transition-all duration-300 gold-glow"
          >
            Book Appointment
          </button>
        </div>
      </section>

      {/* About Section */}
      <section className="py-20 md:py-32 bg-[#0A0A0A]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-4 text-white">
              About <span className="text-[#D4AF37]">Magic Touch</span>
            </h2>
            <div className="w-24 h-1 bg-[#D4AF37] mx-auto"></div>
          </div>
          
          <div className="space-y-8">
            <div className="bg-neutral-900/30 border-l-4 border-[#D4AF37] p-8 md:p-10">
              <p className="text-[#A3A3A3] text-lg md:text-xl leading-relaxed">
                At Magic Touch Hair Studio, our team of top-notch stylists collaborates to transcend ordinary beauty standards, delivering extraordinary transformations that leave you feeling confident and glamorous. From professional hair coloring to advanced hair treatments, our comprehensive services cater to every aspect of your beauty regimen. As the premier studio in Kandivali, we pride ourselves on our commitment to excellence and client satisfaction.
              </p>
            </div>
            
            <div className="bg-neutral-900/30 border-l-4 border-[#D4AF37] p-8 md:p-10">
              <p className="text-[#A3A3A3] text-lg md:text-xl leading-relaxed">
                With a keen eye for detail and a passion for creativity, our stylists work tirelessly to ensure that each client receives a personalized experience tailored to their unique preferences and needs, which makes us the best studio in the area. Whether you're seeking a trendy new haircut, a beautiful hair transformation for a special occasion, or a relaxing hair spa treatment, at Magic Touch, we've got you covered.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Meet the Expert Section */}
      <section className="py-20 md:py-32 bg-[#121212]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-4 text-white">
              Meet the <span className="text-[#D4AF37]">Expert</span>
            </h2>
            <div className="w-24 h-1 bg-[#D4AF37] mx-auto"></div>
          </div>
          
          <div className="flex flex-col md:flex-row items-center gap-12 bg-neutral-900/50 border border-neutral-800 p-8 md:p-12 hover:border-[#D4AF37]/50 transition-all duration-300">
            <div className="flex-shrink-0">
              <div className="relative">
                <div className="w-64 h-64 rounded-full overflow-hidden border-4 border-[#D4AF37] shadow-[0_0_30px_rgba(212,175,55,0.5)]">
                  <img
                    src="https://customer-assets.emergentagent.com/job_salon-kandivali/artifacts/ry46zype_IMG-20260211-WA0027.jpg"
                    alt="Founder & Lead Stylist"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
            
            <div className="flex-1 text-center md:text-left">
              <h3 className="text-3xl sm:text-4xl font-bold text-[#D4AF37] mb-4">
                The Visionary Behind the Magic
              </h3>
              <p className="text-[#A3A3A3] text-lg md:text-xl leading-relaxed mb-4">
                Founder & Lead Stylist with years of mastery in luxury hair transformations.
              </p>
              <div className="flex items-center justify-center md:justify-start gap-2 mt-6">
                <Star className="text-[#D4AF37] fill-[#D4AF37]" size={20} />
                <Star className="text-[#D4AF37] fill-[#D4AF37]" size={20} />
                <Star className="text-[#D4AF37] fill-[#D4AF37]" size={20} />
                <Star className="text-[#D4AF37] fill-[#D4AF37]" size={20} />
                <Star className="text-[#D4AF37] fill-[#D4AF37]" size={20} />
                <span className="text-white ml-2 font-semibold">Expert Craftsmanship</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Little Stars Corner Section */}
      <section className="py-20 md:py-32 bg-[#0A0A0A]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-4 text-white">
              Little Stars <span className="text-[#D4AF37]">Corner</span>
            </h2>
            <div className="w-24 h-1 bg-[#D4AF37] mx-auto"></div>
          </div>
          
          <div className="flex flex-col md:flex-row-reverse items-center gap-12 bg-neutral-900/50 border border-neutral-800 p-8 md:p-12 hover:border-[#D4AF37]/50 transition-all duration-300">
            <div className="flex-shrink-0">
              <div className="relative">
                <div className="w-80 h-80 overflow-hidden border-4 border-[#D4AF37] shadow-[0_0_30px_rgba(212,175,55,0.5)]">
                  <img
                    src="https://customer-assets.emergentagent.com/job_salon-kandivali/artifacts/gqls6oya_IMG-20260211-WA0028.jpg"
                    alt="Children's Car Seat"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
            
            <div className="flex-1 text-center md:text-left">
              <h3 className="text-3xl sm:text-4xl font-bold text-[#D4AF37] mb-4">
                Grooming for our Little Clients
              </h3>
              <p className="text-[#A3A3A3] text-lg md:text-xl leading-relaxed mb-6">
                We make haircuts fun! Our special car seat ensures your little ones enjoy their grooming session in a playful and safe environment.
              </p>
              <div className="inline-flex items-center gap-3 bg-[#D4AF37]/10 border border-[#D4AF37]/30 px-6 py-3">
                <Sparkles className="text-[#D4AF37]" size={24} />
                <span className="text-[#D4AF37] font-semibold text-lg">Making Every Visit Magical for Kids!</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Highlights Section */}
      <section className="py-20 md:py-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-neutral-900 border border-neutral-800 p-8 text-center hover:border-[#D4AF37]/50 transition-colors duration-300">
              <Sparkles className="text-[#D4AF37] mx-auto mb-4" size={40} />
              <h3 className="text-2xl font-bold mb-2 text-white">Expert Stylists</h3>
              <p className="text-[#A3A3A3]">Highly trained professionals with years of experience</p>
            </div>
            <div className="bg-neutral-900 border border-neutral-800 p-8 text-center hover:border-[#D4AF37]/50 transition-colors duration-300">
              <MapPin className="text-[#D4AF37] mx-auto mb-4" size={40} />
              <h3 className="text-2xl font-bold mb-2 text-white">Prime Location</h3>
              <p className="text-[#A3A3A3]">Conveniently located in Thakur Complex, Kandivali East</p>
            </div>
            <div className="bg-neutral-900 border border-neutral-800 p-8 text-center hover:border-[#D4AF37]/50 transition-colors duration-300">
              <Star className="text-[#D4AF37] mx-auto mb-4 fill-[#D4AF37]" size={40} />
              <h3 className="text-2xl font-bold mb-2 text-white">Top Rated</h3>
              <p className="text-[#A3A3A3]">4.5 stars on Google with hundreds of satisfied customers</p>
            </div>
          </div>
        </div>
      </section>

      {/* Exclusive Offers Section */}
      <ExclusiveOffers />

      {/* Hair Patch Transformation Section */}
      <section className="py-20 md:py-32 bg-[#121212]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-4 text-white">
              Life-Changing <span className="text-[#D4AF37]">Hair Transformations</span>
            </h2>
            <div className="w-24 h-1 bg-[#D4AF37] mx-auto mb-6"></div>
            <p className="text-lg text-[#A3A3A3] max-w-3xl mx-auto">
              Premium non-surgical hair patch solutions. Get your natural look and confidence back in just one session.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            {/* Before Image */}
            <div className="relative group">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 z-10">
                <span className="bg-red-600 text-white px-6 py-2 text-sm font-bold uppercase tracking-wider">
                  Before
                </span>
              </div>
              <div className="border-4 border-neutral-700 overflow-hidden hover:border-neutral-600 transition-all duration-300">
                <img
                  src="https://customer-assets.emergentagent.com/job_salon-kandivali/artifacts/d7u7lgh7_IMG-20260211-WA0007.jpg"
                  alt="Before Hair Patch Treatment"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>

            {/* After Image */}
            <div className="relative group">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 z-10">
                <span className="bg-[#D4AF37] text-black px-6 py-2 text-sm font-bold uppercase tracking-wider">
                  After
                </span>
              </div>
              <div className="border-4 border-[#D4AF37] overflow-hidden shadow-[0_0_40px_rgba(212,175,55,0.6)] hover:shadow-[0_0_60px_rgba(212,175,55,0.8)] transition-all duration-300">
                <img
                  src="https://customer-assets.emergentagent.com/job_salon-kandivali/artifacts/hbinhv98_IMG-20260211-WA0008.jpg"
                  alt="After Hair Patch Treatment"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>
          </div>

          {/* Feature Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-16">
            <div className="bg-neutral-900 border border-neutral-800 p-6 text-center hover:border-[#D4AF37]/50 transition-colors duration-300">
              <div className="text-[#D4AF37] text-3xl font-bold mb-2">100%</div>
              <p className="text-white font-semibold mb-1">Natural Look</p>
              <p className="text-[#A3A3A3] text-sm">Undetectable results</p>
            </div>
            <div className="bg-neutral-900 border border-neutral-800 p-6 text-center hover:border-[#D4AF37]/50 transition-colors duration-300">
              <div className="text-[#D4AF37] text-3xl font-bold mb-2">1 Day</div>
              <p className="text-white font-semibold mb-1">Quick Solution</p>
              <p className="text-[#A3A3A3] text-sm">Same-day transformation</p>
            </div>
            <div className="bg-neutral-900 border border-neutral-800 p-6 text-center hover:border-[#D4AF37]/50 transition-colors duration-300">
              <div className="text-[#D4AF37] text-3xl font-bold mb-2">Non-Surgical</div>
              <p className="text-white font-semibold mb-1">Safe & Comfortable</p>
              <p className="text-[#A3A3A3] text-sm">No pain, no recovery</p>
            </div>
          </div>

          {/* CTA */}
          <div className="text-center mt-12">
            <button
              onClick={handleBooking}
              data-testid="hair-patch-book-btn"
              className="bg-[#D4AF37] text-black font-semibold px-12 py-4 uppercase tracking-widest text-sm hover:bg-[#E5C15D] transition-all duration-300 gold-glow"
            >
              Book Your Transformation
            </button>
          </div>
        </div>
      </section>

      {/* Customer Love Section */}
      <section className="py-20 md:py-32 bg-[#121212]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl sm:text-5xl font-bold text-center mb-16 text-white">
            Customer <span className="text-[#D4AF37]">Love</span>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {reviews.map((review, index) => (
              <div
                key={index}
                data-testid={`review-${index + 1}`}
                className="bg-neutral-900 p-8 border-l-2 border-[#D4AF37]"
              >
                <div className="flex mb-4">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <Star key={star} className="text-[#D4AF37] fill-[#D4AF37]" size={16} />
                  ))}
                </div>
                <p className="text-[#A3A3A3] mb-4 italic">"{review.text}"</p>
                <p className="text-white font-semibold">- {review.author}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 md:py-32">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl sm:text-5xl font-bold mb-6 text-white">
            Ready to Transform Your Look?
          </h2>
          <p className="text-lg text-[#A3A3A3] mb-8">
            Book your appointment today and experience luxury grooming
          </p>
          <button
            data-testid="cta-book-btn"
            onClick={handleBooking}
            className="bg-[#D4AF37] text-black font-semibold px-12 py-4 uppercase tracking-widest text-sm hover:bg-[#E5C15D] transition-all duration-300 gold-glow"
          >
            Book Now via WhatsApp
          </button>
        </div>
      </section>
    </div>
  );
}
